import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { AuthService } from 'src/app/modules/auth/services/auth.service'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
	constructor(public authServ: AuthService, private dialog: MatDialog) {}
	@Output() closeMenu = new EventEmitter()
	tabs: any = {
		openFinance: false,
		openPayout: false,
		openOffer: false,
		openStore: false,
		openPointingSystem: false,
		openCustomization: false,
	}
	openStore: boolean = false
	ngOnInit(): void {}
	closeFun() {
		if (window.innerWidth <= 1024) {
			this.closeMenu.emit()
		}
	}
	closeSubMenu(currentTab: string) {
		let allTabs = Object.keys(this.tabs)
		if (allTabs.includes(currentTab)) {
			let tabs = Object.keys(this.tabs).forEach((ele: any) => {
				ele == currentTab ? (this.tabs[ele] = true) : (this.tabs[ele] = false)
			})
		} else {
			let tabs = Object.keys(this.tabs).forEach((ele: any) => {
				this.tabs[ele] = false
			})
		}
	}
}
